module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_9016.c7049549.png";